import { render, staticRenderFns } from "./ReservationPayment.vue?vue&type=template&id=0cd2493c&scoped=true&"
import script from "./ReservationPayment.vue?vue&type=script&lang=js&"
export * from "./ReservationPayment.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPayment.vue?vue&type=style&index=0&id=0cd2493c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd2493c",
  null
  
)

export default component.exports